export function initIEStickybar() {
  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (isIE11) {
    var nav = document.querySelector(".sticky");
    var stickyOffset = nav.getBoundingClientRect().top;
    window.addEventListener("scroll", function () {
      if (window.pageYOffset > stickyOffset) {
        nav.classList.add("stuck");
      } else {
        nav.classList.remove("stuck");
      }
    });
  }
}